import { FC, memo } from 'react'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import Link from 'next/link'
import { Param } from '@ucheba/ui/components/Param/desktop'
import { useProfCardStats } from '../bll'
import { IProfCardStatsProps } from '../types'

/** Статистика профессии */
const ProfCardStats: FC<IProfCardStatsProps> = (props) => {
  const {
    institutions,
    collages,
    courses,
    specialities,
    hrefInstitutions,
    hrefCollages,
    hrefCourses,
  } = useProfCardStats(props)

  return (
    <Grid spacing='small'>
      {institutions && (
        <GridCol uxs='auto'>
          <Link href={hrefInstitutions}>
            <Param
              entity={institutions.entity}
              color='blue'
              clarification={institutions.clarification}
              fontSize='large'
            />
          </Link>
        </GridCol>
      )}

      {collages && (
        <GridCol uxs='auto'>
          <Link href={hrefCollages}>
            <Param
              entity={collages.entity}
              color='blue'
              clarification={collages.clarification}
              fontSize='large'
            />
          </Link>
        </GridCol>
      )}

      {courses && (
        <GridCol uxs='auto'>
          <Link href={hrefCourses}>
            <Param
              entity={courses.entity}
              color='blue'
              clarification={courses.clarification}
              fontSize='large'
            />
          </Link>
        </GridCol>
      )}

      {specialities && (
        <GridCol uxs='auto'>
          <a href='#specialities'>
            <Param
              entity={specialities.entity}
              color='blue'
              clarification={specialities.clarification}
              fontSize='large'
            />
          </a>
        </GridCol>
      )}
    </Grid>
  )
}

export default memo(ProfCardStats)
